import { apiCall, API_CONFIG } from './api';

const appendCreateProductPayload = (formData, payload = {}) => {
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || key === 'imageFile' || key === 'variantImageFiles' || key === 'variantsData') {
      return;
    }
    formData.append(key, value);
  });

  if (payload.imageFile instanceof File) {
    formData.append('image', payload.imageFile);
  }

  if (payload.variantsData) {
    formData.append('variantsData', JSON.stringify(payload.variantsData));
    (payload.variantImageFiles || []).forEach((file) => {
      formData.append('variant_images', file);
    });
  }
};

const appendUpdateProductPayload = (formData, payload = {}) => {
  Object.entries(payload).forEach(([key, value]) => {
    if (value === undefined || value === null || key === 'imageFile' || key === 'variantImageFiles' || key === 'variantsData') {
      return;
    }
    formData.append(key, value);
  });

  if (payload.imageFile instanceof File) {
    formData.append('image', payload.imageFile);
  }

  if (payload.variantsData) {
    formData.append('variantsData', JSON.stringify(payload.variantsData));
    (payload.variantImageFiles || []).forEach((file) => {
      formData.append('variant_images', file);
    });
  }
};

export const productsAPI = {
  getProductsList: async ({ page = 1, limit = 20, search, isAvailable, region }) => {
    try {
      const payload = {
        page,
        limit,
      };

      if (search) payload.search = search;
      if (isAvailable !== undefined && isAvailable !== '') payload.isAvailable = isAvailable;
      if (region === 'qatar' || region === 'india') payload.region = region;

      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.PRODUCTS}/list`,
        {
          method: 'POST',
          body: JSON.stringify(payload),
        }
      );

      if (response.success) {
        return {
          success: true,
          data: response.data?.products || [],
          pagination: response.data?.pagination,
          msg: response.msg,
        };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to fetch products',
      };
    } catch (error) {
      console.error('List products error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },

  getProductById: async (id) => {
    try {
      const response = await apiCall(`${API_CONFIG.ENDPOINTS.PRODUCTS}/${id}`, {
        method: 'GET',
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to fetch product',
      };
    } catch (error) {
      console.error('Get product error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },

  createProduct: async (payload) => {
    try {
      const hasFile = payload.imageFile instanceof File;
      const hasVariants = payload.variantsData !== undefined;

      let requestBody;
      if (!hasFile && !hasVariants) {
        const { imageFile, variantImageFiles, variantsData, ...rest } = payload;
        requestBody = rest;
      } else {
        requestBody = new FormData();
        appendCreateProductPayload(requestBody, payload);
      }

      const response = await apiCall(`${API_CONFIG.ENDPOINTS.PRODUCTS}/add`, {
        method: 'POST',
        body: requestBody instanceof FormData ? requestBody : JSON.stringify(requestBody),
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to create product',
      };
    } catch (error) {
      console.error('Create product error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },

  updateProduct: async (productId, payload) => {
    try {
      const hasFile = payload.imageFile instanceof File;
      const hasVariants = payload.variantsData !== undefined;

      let requestBody;
      if (!hasFile && !hasVariants) {
        requestBody = { ...payload, id: productId };
        delete requestBody.imageFile;
        delete requestBody.variantImageFiles;
        delete requestBody.variantsData;
      } else {
        requestBody = new FormData();
        requestBody.append('id', productId);
        appendUpdateProductPayload(requestBody, payload);
      }

      const response = await apiCall(`${API_CONFIG.ENDPOINTS.PRODUCTS}/update`, {
        method: 'PUT',
        body: requestBody instanceof FormData ? requestBody : JSON.stringify(requestBody),
      });

      if (response.success) {
        return { success: true, data: response.data, msg: response.msg };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to update product',
      };
    } catch (error) {
      console.error('Update product error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },

  deleteProduct: async (productId) => {
    try {
      const response = await apiCall(
        `${API_CONFIG.ENDPOINTS.PRODUCTS}/${productId}`,
        { method: 'DELETE' }
      );

      if (response.success) {
        return { success: true, msg: response.msg };
      }

      return {
        success: false,
        error: response.message || response.msg || 'Failed to delete product',
      };
    } catch (error) {
      console.error('Delete product error:', error);
      return { success: false, error: 'Network error. Please try again.' };
    }
  },
};
